import React, {useContext, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {IndividualContext} from "../../individual-context.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const Bos = () => {
    const navigate = navigateHook();
    const {individualInfo, boName} = useContext(IndividualContext)

    const [columnDefs] = useState([
        {headerName: "Número", field: "id"},
        {headerName: "Status", field: "status"},
        {headerName: "Natureza(s)", field: "reason", flex: 1},
        {headerName: "D/H do fato", field: "dtfact", width: 150},
    ]);

    const onRowClicked = ({data}) => {
        const id = data.id.replace("/", "-");
        const urlDev = `/bo/redirect/${id}`;
        
        navigate(urlDev, true)
    }

    return (
        <Card>
            <Card.Header className={"gap-2"}>
                <Card.Title>
                    {boName}
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className={"aggrid-row-pointer h-[calc(100vh-185px)]"}>
                    <AgGridReact
                        rowData={individualInfo?.bos}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onRowClicked={onRowClicked}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default Bos;